export const ASSET_NAME = 'terms-of-service';

// Legal text is served from the in-repo termsOfServiceContent.json (see
// TermsOfServicePage.js) — the Console CMS copy is ignored, so there is
// nothing to fetch. Keeping a resolved loadData preserves the SSR contract.
export const loadData = (params, search) => dispatch => {
  return Promise.resolve();
};
